const defineDeferredProperty = (key, func) => (object) => {
    Object.defineProperty(object, key, {
        configurable: true,
        enumerable: true,
        get() {
            const value = func(object);
            Object.defineProperty(this, key, {
                configurable: true,
                enumerable: true,
                writable: true,
                value,
            });
            return value;
        },
        set(value) {
            Object.defineProperty(this, key, {
                configurable: true,
                enumerable: true,
                writable: true,
                value,
            });
        },
    });
    return object;
};
const addField = (key, func) => (object) => defineDeferredProperty(key, func)(object);
const setField = (key, func) => (object) => defineDeferredProperty(key, func)(object);
const merge = (overlay) => (base) => {
    const merged = Object.defineProperties({}, Object.getOwnPropertyDescriptors(base));
    Object.defineProperties(merged, Object.getOwnPropertyDescriptors(overlay));
    return merged;
};
export const Deferred = {
    addField,
    setField,
    merge,
};
//# sourceMappingURL=Deferred.js.map